module.exports = __webpack_public_path__ + "img/add_empty.a0e171b8.png";